//#region Asset Imports

import 'devextreme/ui/form'
import 'devextreme/ui/popup'
import 'devextreme/ui/toolbar'

//#endregion

import { SERVICE_NAME as SYSTEM_SERVICE_NAME } from '../../../../services/system/system.service'
import { USER_SESSION_SERVICE_NAME } from '../../../../services/user-session'

import { ConsumerDetailsNotificationsController } from "./consumers-details-notifications.controller"

//#region Asset Imports

import './consumers-details-notifications.scss'
import * as TEMPLATE from './consumers-details-notifications.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'consumerDetailsNotifications'

export class ConsumerDetailsNotificationsComponent implements ng.IComponentOptions {

    controller = [USER_SESSION_SERVICE_NAME, SYSTEM_SERVICE_NAME, ConsumerDetailsNotificationsController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}
